exports.default = {
  'copy_code': 'Copy code',
  'copy_success': 'Copy successful!',
  'copy_failed': 'Copy failed!',
  'image_save_success': 'Image saved successfully',
  'image_save_failed': 'Image save failed',
  'file_created': 'File Created',
  'file_creating': 'File Creating',
  'file_creation_stopped': 'File Creation Stopped',
  'action_finished': 'Action Finished',
  'action_executing': 'Executing Action',
  'action_stopped': 'Action Stopped',
  'completed': 'Completed',
  'in_progress': 'In Progress',
  'stopped': 'Stopped'
}
